/**
 * @voltxampere/ui — 7432 quad OR TTL variant (Sprint 41-4)
 *
 * Reference: TI SN5432. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7432 = {
    id: "7432",
    nameTr: "7432 (4'lü OR, DIP-14)",
    nameEn: "7432 (Quad OR, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7432",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "OR",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 10e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7432.js.map